<div class="legenda">
  <div *ngIf="data.pop.load" class="mb-3">
    <img style="height: 30px" class="mr-4" src="./assets/images/ico-pop.png" alt="" />
    <span class="text-uppercase">POP</span>
  </div>
  <div *ngIf="data.pcn.load" class="mb-3">
    <img style="height: 30px;" class="mr-4" src="./assets/images/ico-pop-cd.png" alt="">
    <span class="text-uppercase">PCN</span>
  </div>
  <div *ngIf="data.pop_ola.load" class="mb-3">
    <img style="height: 30px;" class="mr-4" src="./assets/images/ico-pop-ola.png" alt="">
    <span class="text-uppercase">OLA</span>
  </div>
  <div *ngIf="(env.controls.agf && data.pop_agf.load) || env.controls.agf_pop" class="mb-3">
    <img style="height: 30px;" class="mr-4" src="./assets/images/ico-pop-yellow.png" alt="">
    <span class="text-uppercase">BI1G</span>
  </div>
  <div *ngIf="data.poi.load" class="mb-3">
    <img style="height: 30px" class="mr-4" src="./assets/images/ico-poi.png" alt="" />
    <span class="text-uppercase">Point of Interest</span>
  </div>
  <div *ngIf="data.pfs.load" class="mb-3">
    <img style="height: 30px" class="mr-4" src="./assets/images/ico-pfs.png" alt="" />
    <span class="text-uppercase">PFS</span>
  </div>
  <div *ngIf="data.roe.load && !data.punti_intermedi.load" class="mb-3">
    <img style="height: 30px" class="mr-4" src="./assets/images/ico-roe.png" alt="" />
    <span class="text-uppercase">ROE</span>
  </div>
  <div *ngIf="data.roe.load && data.punti_intermedi.load" class="mb-3">
    <img style="height: 30px" class="mr-4" src="./assets/images/ico-pfs.png" alt="" />
    <span class="text-uppercase">ROE</span>
  </div>
  <div *ngIf="data.cno.load && data.punti_intermedi.load" class="mb-3">
    <img style="height: 30px" class="mr-4" src="./assets/images/ico-pfs.png" alt="" />
    <span class="text-uppercase">CNO</span>
  </div>
  <div *ngIf="data.pozzetto.load && data.punti_intermedi.load" class="mb-3">
    <img style="height: 30px" class="mr-4" src="./assets/images/ico-pfs.png" alt="" />
    <span class="text-uppercase">Pozzetti</span>
  </div>
  <div *ngIf="data.noa.load" class="mb-3">
    <img style="height: 30px" class="mr-4" src="./assets/images/ico-noa.png" alt="" />
    <span class="text-uppercase">NODE</span>
  </div>
  <div *ngIf="data.school.load" class="mb-3">
    <img style="height: 30px" class="mr-4" src="./assets/images/ico-noa.png" alt="" />
    <span class="text-uppercase">School</span>
  </div>
  <div *ngIf="data.healthcare.load" class="mb-3">
    <img style="height: 30px" class="mr-4" src="./assets/images/ico-noa.png" alt="" />
    <span class="text-uppercase">Healthcare</span>
  </div>
  <div *ngIf="data.building.load && data.area_types.includes('CoveredAB')" class="mb-3">
    <img class="mr-4" src="./assets/images/civic_marker.png" alt="">
    <span class="key-text text-uppercase">Network available for PON & P2P Urban Area</span>
  </div>
  <div *ngIf="data.building.load && data.area_types.includes('CoveredCD')" class="mb-4">
    <img style="width: 22px;" class="mr-4" src="./assets/images/civic_marker_green.png" alt="">
    <span class="key-text text-uppercase">Network available for PON & P2P Rural Area</span>
  </div>
  <div *ngIf="data.building.load && data.area_types.includes('Designed')" class="mb-3">
    <img class="mr-4" src="./assets/images/civic_marker_blue.png" alt="">
    <span class="key-text text-uppercase">Network prospected for PON & P2P</span>
  </div>
  <div *ngIf="env.controls.agf && data.building.load && data.area_types.includes('CoveredAGF')" class="mb-3">
    <img class="mr-4" src="./assets/images/civic_marker_yellow.png" alt="">
    <span class="key-text text-uppercase">Network available for BI1G</span>
  </div>
  <div *ngIf="data.kml" class="mb-3">
    <img style="height: 30px;" class="mr-4" src="./assets/images/ico-mappa-copertura-legenda.png" alt="">
    <span class="text-uppercase">Coverage map</span>
  </div>
  <div *ngIf="data.kml" class="mb-3">
    <img style="height: 30px;" class="mr-4" src="./assets/images/ico-cd-map.png" alt="">
    <span class="text-uppercase">Coverage white areas</span>
  </div>
  <div *ngIf="data.kml" class="mb-3">
    <img style="height: 30px;" class="mr-4" src="./assets/images/ico-prospect-map.png" alt="">
    <span class="text-uppercase">Coverage designed areas</span>
  </div>
</div>